import APIClient from '@/shared/http/clients/api'

const RESOURCE = '/admin/ad-sync'
const APICore = process.env.APIBaseURLCore

export default {
  // Sincronizacao manual
  syncUsers (usernames) {
    return APIClient.post(`${APICore}${RESOURCE}/sync-users`, { usernames, applyPermissions: true })
  },

  // Mapeamentos
  getAllMappings () {
    return APIClient.get(`${APICore}${RESOURCE}/mappings`)
  },

  createMapping (mapping) {
    return APIClient.post(`${APICore}${RESOURCE}/mappings`, mapping)
  },

  updateMapping (id, mapping) {
    return APIClient.put(`${APICore}${RESOURCE}/mappings/${id}`, mapping)
  },

  deleteMapping (id) {
    return APIClient.delete(`${APICore}${RESOURCE}/mappings/${id}`)
  },

  // Health check
  testConnection () {
    return APIClient.get(`${APICore}${RESOURCE}/test-connection`)
  },

  // Grupos disponiveis
  getAvailableGroups () {
    return APIClient.get(`${APICore}${RESOURCE}/available-groups`)
  },

  // Grupos da conta de servico
  getServiceAccountGroups () {
    return APIClient.get(`${APICore}${RESOURCE}/service-account-groups`)
  },

  // Dashboard / Monitoramento
  getDashboardMetrics () {
    return APIClient.get(`${APICore}${RESOURCE}/dashboard/metrics`)
  },

  getExecutions () {
    return APIClient.get(`${APICore}${RESOURCE}/dashboard/executions`)
  },

  getExecutionDetails (executionId) {
    return APIClient.get(`${APICore}${RESOURCE}/dashboard/executions/${executionId}`)
  },

  syncFull () {
    return APIClient.post(`${APICore}${RESOURCE}/sync-full`)
  },

  // Usuários disponíveis para importação
  getAvailableUsers () {
    return APIClient.get(`${APICore}${RESOURCE}/available-users`)
  }
}



// WEBPACK FOOTER //
// ./src/shared/http/repositories/adsync/adsync.js